module.exports = __webpack_public_path__ + "img/edit.106a2ade.svg";